import React, { lazy, Suspense } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import Loader from './component/Loader/Loader';
import NavMotion from './layout/NavMotion';
import MainLayout from './layout/MainLayout';
import GuestGuard from './component/Auth/GuestGuard';
import AuthGuard from './component/Auth/AuthGuard';
import MinimalLayout from './layout/MinimalLayout';
// import AppLayout from './layout/AppLayout/index';
import NotFound from './views/Pages/NotFound/index.js';
import ChatLayout from './layout/ChatLayout/index.js';
const AuthLogin = lazy(() => import('./views/Login'));
const AuthForgot = lazy(() => import('./views/ForgotPass'));
const AuthConfirm = lazy(() => import('./views/ConfirmCode'));
const App = lazy(() => import('./views/Dashboard/App/index.js'));
const AppSetting = lazy(() => import('./views/Dashboard/App/setting.js'));
const DashboardDefault = lazy(() => import('./views/Dashboard/Default'));
const Logout = lazy(() => import('./views/Users/logout'));
const Chat = lazy(() => import('./views/Chat'));

const Routes = () => {
  const location = useLocation();

  return (
    <AnimatePresence>
      <Suspense fallback={<Loader />}>
        <Switch>
          <Redirect exact from="/" to="/dashboard/app" />
          <Route path={['/login', '/forgot', '/confirm']}>
            <MinimalLayout>
              <Switch location={location} key={location.pathname}>
                <NavMotion>
                  <GuestGuard>
                    <Route path="/login" component={AuthLogin} />
                    <Route path="/forgot" component={AuthForgot} />
                    <Route path="/confirm" component={AuthConfirm} />
                  </GuestGuard>
                </NavMotion>
              </Switch>
            </MinimalLayout>
          </Route>
          <Route path={['/dashboard/app', '/dashboard/default', '/users/logout', '/settings/app']}>
            <MainLayout>
              <Switch location={location} key={location.pathname}>
                <NavMotion>
                  <AuthGuard>
                    <Route path="/dashboard/app" component={App} />
                    <Route path="/dashboard/default" component={DashboardDefault} />
                    <Route path="/users/logout" component={Logout} />
                    <Route path="/settings/app" component={AppSetting} />
                    <Route path="/dashboard/chat" component={Chat} />
                  </AuthGuard>
                </NavMotion>
              </Switch>
            </MainLayout>
          </Route>
          <Route path={['/dashboard/chat']}>
            <ChatLayout>
              <Switch location={location} key={location.pathname}>
                <NavMotion>
                  <AuthGuard>
                    <Route path="/dashboard/chat" component={Chat} />
                  </AuthGuard>
                </NavMotion>
              </Switch>
            </ChatLayout>
          </Route>
          <Redirect to="/login" />
          <Route component={NotFound} />
        </Switch>
      </Suspense>
    </AnimatePresence>
  );
};

export default Routes;
